import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import { useAuthStore } from './store/auth';

const pinia = createPinia();

const app = createApp(App);
app.use(pinia);
app.use(router);

const authStore = useAuthStore();
authStore.initializeAuth();

app.mount('#app');
